import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import { fromJS } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import moment from 'moment';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectStepBaggageAndPersonalItemsStarr, makeSelectStepBaggageAndPersonalItemsStarrErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';
import { makeSelectInsuredsList, makeSelectIsClaimForFieldEnabled, makeSelectJSONVersion } from '../../App/selectors';
import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  ValidateGroup,
  Validate,
  ErrorMessage,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormData,
  resetFormTravelInterruption,
  resetFormTravelDelay,
  resetFormAirlineForDamaged,
  resetFormAirlineBaggageDelay,
  getFlightStatusRequest,
  resetFormFields,
} from './actions';
import DatePicker from '../components/DatePicker/index';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import {
  makeSelectDepreciationTypes,
} from '../../ClaimList/selectors';
import { DescriptionListForBaggageDelay } from './components/DescriptionOfItemForBaggageDelay';
import { DescriptionList } from './components/DescriptionOfItem';
import { SpecifiedItemList } from './components/SpecifiedItem';
import Section from '../components/Section';
import ControlContainer from '../components/ControlContainer';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import TimePickerInput from '../../../components/TimePickerInput';
import FlightDatePicker from '../components/FlightDatePicker/index';
import { stepBaggageAndPersonalItemsStarrLookup } from '../../FastCover/dataMapper/claimCodeMapper';
import { required, checkDateOnly, checkFlightDateOnly, checkFlightNumberOnly } from '../../../utils/validation/validator';
import { FlightDetailsForDamagedLost } from './components/FlightDetailsForDamagedLost';
import { FlightDetailsForBaggageDelay } from './components/FlightDetailsForBaggageDelay';
export class StepBaggageAndPersonalItemsStarr extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(6);
  };

  onDescriptionOfItemsChange = (data) => {
    this.props.onFormDataChange('form.descriptionOfItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onDescriptionOfItemsForBaggageDelayChange = (data) => {
    this.props.onFormDataChange('form.descriptionOfItemsForDamaged', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onSpecifiedItems = (data) => {
    this.props.onFormDataChange('form.specifiedItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  flightVerificationForBaggageDelay = (flightObjectName) => () => {
    const { flightNumberForBaggageDelay, flightDateForBaggageDelay } = this.props.form;
    const isFlightNumberValid = checkFlightNumberOnly(flightNumberForBaggageDelay);
    const isFlightDateValid = checkFlightDateOnly(flightDateForBaggageDelay);
    if (isFlightNumberValid && isFlightDateValid) {
      if (flightNumberForBaggageDelay && flightDateForBaggageDelay) {
        this.props.getFlightStatus(flightNumberForBaggageDelay, flightDateForBaggageDelay, flightObjectName, this.props.stepName, '');
      }
    }
  };

  flightVerificationForDamaged = (flightObjectName) => () => {
    const { flightNumberForDamaged, flightDateForDamaged } = this.props.form;
    const isFlightNumberValid = checkFlightNumberOnly(flightNumberForDamaged);
    const isFlightDateValid = checkFlightDateOnly(flightDateForDamaged);
    if (isFlightNumberValid && isFlightDateValid) {
      if (flightNumberForDamaged && flightDateForDamaged) {
        this.props.getFlightStatus(flightNumberForDamaged, flightDateForDamaged, flightObjectName, this.props.stepName, '');
      }
    }
  };

  handleFlightSelection = (propertyName, index) => {
    this.props.onFormDataChange(propertyName, index);
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const {
      areYouClaimingForDamagedLostOrStolenLuggage,
      areYouClaimingForBaggageDelay,
    } = this.props.form;
    const isSelectBenefit = areYouClaimingForDamagedLostOrStolenLuggage === 'true' || areYouClaimingForBaggageDelay === 'true';
    const valid = isSelectBenefit && this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  handleNext = () => {
    const {
      areYouClaimingForDamagedLostOrStolenLuggage,
      areYouClaimingForBaggageDelay,
    } = this.props.form;
    const isSelectBenefit = areYouClaimingForDamagedLostOrStolenLuggage === 'true' || areYouClaimingForBaggageDelay === 'true';
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = isSelectBenefit && this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    // this.props.makeDirty(6);
  };

  handleChangeFlightDetail = (flightObjectName, propertyName) => (eventOrDay) => {
    const { form } = this.props;
    const flights = form[flightObjectName].flights || [];

    // Determine the value based on whether it's a date picker event or regular input event
    const value = eventOrDay && eventOrDay.target ? eventOrDay.target.value : eventOrDay;

    if (flights.length === 1) {
      // Update first flight's property
      const updatedFlight = { ...flights[0], [propertyName]: value };
      const updatedFlights = [updatedFlight];
      this.props.onFormDataChange(`form.${flightObjectName}.flights`, updatedFlights);
    } else if (flights.length > 1 && form[flightObjectName].selectedFlightIndex !== null) {
      // Update selected flight's property
      const updatedFlights = flights.map((flight, index) => {
        if (index === form[flightObjectName].selectedFlightIndex) {
          return { ...flight, [propertyName]: value };
        }
        return flight;
      });
      this.props.onFormDataChange(`form.${flightObjectName}.flights`, updatedFlights);
    }
  };

  handleReasonsForTripInterruption = (propertyName) => (event) => {
    const { reasonsForTripInterruption } = this.props.form;
    const reasons = !!reasonsForTripInterruption && typeof reasonsForTripInterruption.toJS === 'function'
      ? reasonsForTripInterruption.toJS()
      : reasonsForTripInterruption || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  handleChangeClaimingFor = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  handleReasonsForDelay = (propertyName) => (event) => {
    const { reasonsForDelay } = this.props.form;
    const reasons = !!reasonsForDelay && typeof reasonsForDelay.toJS === 'function'
      ? reasonsForDelay.toJS()
      : reasonsForDelay || [];
    const listChecked = _.cloneDeep(reasons);
    const target = event.target;
    const name = target.name;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (value) {
      listChecked.push(name);
    } else {
      listChecked.splice(listChecked.indexOf(name), 1);
    }
    this.props.onFormDataChange(propertyName, listChecked);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleChangeTypeOfTransport = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  renderDescriptionOfItemsForBaggageDelay() {
    const { descriptionOfItemsForDamaged } = this.props.form;
    const newDescriptionOfItemsForDamaged = this.appendIds(descriptionOfItemsForDamaged);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <DescriptionListForBaggageDelay
          data={newDescriptionOfItemsForDamaged}
          onChange={this.onDescriptionOfItemsForBaggageDelayChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderForBaggageDelay() {
    const {
      areYouClaimingForBaggageDelay,
      companyBaggageDelay,
      travelSupplierInformation,
      originForBaggageDelay,
      destinationForBaggageDelay,
      dateWhenYourLuggageWasDelayed,
      timeWhenYourLuggageWasDelayed,
      dateWhenYourLuggageWasReturned,
      timeWhenYourLuggageWasReturned,
      haveYouMadeAClaimWithYourTravelProvider,
      flightNumberForBaggageDelay,
      flightDateForBaggageDelay,
      flightDetailsForBaggageDelay = {},
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const newTimeWhenYourLuggageWasDelayed = timeWhenYourLuggageWasDelayed ? moment(timeWhenYourLuggageWasDelayed) : null;
    const newTimeWhenYourLuggageWasReturned = timeWhenYourLuggageWasReturned ? moment(timeWhenYourLuggageWasReturned) : null;
    const { isSummary, submitted, jsonVersion } = this.props;
    const isReadOnly = submitted || isSummary;
    const isFlightNumberValid = checkFlightNumberOnly(flightNumberForBaggageDelay);
    const isFlightDateValid = checkFlightDateOnly(flightDateForBaggageDelay);
    const showSectionFlightDetails = flightDetailsForBaggageDelay && (flightDetailsForBaggageDelay.onSuccessFlighAPIRequest || flightDetailsForBaggageDelay.callFailFlighAPIRequest);
    const isDisable = isReadOnly || (flightDetailsForBaggageDelay && (flightDetailsForBaggageDelay.onSuccessFlighAPIRequest || !flightDetailsForBaggageDelay.manuallyEnterFlight));
    const isVersion15AndAbove = jsonVersion >= 15;
    return (
      areYouClaimingForBaggageDelay === 'true' && (
        <div>
          <div className={'ml-5'}>
            <div className={'row'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelSupplierWhereDelayOccurred} />
              </PageSectionHeader>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="companyBaggageDelay"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={companyBaggageDelay}
                  fieldName={messages.companyYouWereTravelingWith}
                >
                  <Textbox
                    name="companyBaggageDelay"
                    type="text"
                    onChange={this.handleChange('form.companyBaggageDelay')}
                    value={companyBaggageDelay}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.companyYouWereTravelingWith}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            {isVersion15AndAbove && (
              <FlightDetailsForBaggageDelay
                form={this.props.form}
                getFlightStatus={this.props.getFlightStatus}
                isReadOnly={isReadOnly}
                summaryFormValue={this.summaryFormValue}
                isSummary={isSummary}
                handleChangeTypeOfTransport={this.handleChangeTypeOfTransport}
                checkFlightNumberOnly={checkFlightNumberOnly}
                checkFlightDateOnly={checkFlightDateOnly}
                loading={this.props.loading}
                handleChange={this.handleChange}
                handleDayChange={this.handleDayChange}
                handleChangeFlightDetail={this.handleChangeFlightDetail}
                validatorGroup={this.validatorGroup}
                validationCounter={this.state.validationCounter}
                flightVerificationForBaggageDelay={this.flightVerificationForBaggageDelay}
                showSpinnerForElement={this.showSpinnerForElement}
                handleFlightSelection={this.handleFlightSelection}
              />
            )}
            {!isVersion15AndAbove && (
              <div>
                <div className={'row ml-2'}>
                  <div className={'col-sm-12 form-group'}>
                    <FlexBox>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="Tour Operator"
                          checked={travelSupplierInformation === 'Tour Operator'}
                          onChange={this.handleChangeClaimingFor('form.travelSupplierInformation')}
                          onClick={this.props.onResetFormAirlineBaggageDelay}
                        />
                        <FormattedMessage {...messages.tourOperator} />
                      </OptionsContainer>
                    </FlexBox>
                    <FlexBox className={'pt-2'}>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="Cruise Line"
                          checked={travelSupplierInformation === 'Cruise Line'}
                          onChange={this.handleChangeClaimingFor('form.travelSupplierInformation')}
                          onClick={this.props.onResetFormAirlineBaggageDelay}
                        />
                        <FormattedMessage {...messages.cruiseLine} />
                      </OptionsContainer>
                    </FlexBox>
                    <FlexBox className={'pt-2'}>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="Airline"
                          checked={travelSupplierInformation === 'Airline'}
                          onChange={this.handleChangeClaimingFor('form.travelSupplierInformation')}
                          onClick={this.props.onResetFormAirlineBaggageDelay}
                        />
                        <FormattedMessage {...messages.airline} />
                      </OptionsContainer>
                    </FlexBox>
                  </div>
                </div>
                {(travelSupplierInformation === 'Tour Operator' || travelSupplierInformation === 'Cruise Line') && (
                  <div className={'row'}>
                    <div className={'col-sm-6 form-group'}>
                      <Validate
                        name="originForBaggageDelay"
                        validators={[required]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={originForBaggageDelay}
                        fieldName={messages.origin}
                      >
                        <Textbox
                          name="originForBaggageDelay"
                          type="text"
                          onChange={this.handleChange('form.originForBaggageDelay')}
                          value={originForBaggageDelay}
                          disabled={isReadOnly}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={messages.origin}
                          />
                        </ErrorMessage>
                      </Validate>
                    </div>
                    <div className={'col-sm-6 form-group'}>
                      <Validate
                        name="destinationForBaggageDelay"
                        validators={[required]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={destinationForBaggageDelay}
                        fieldName={messages.destination}
                      >
                        <Textbox
                          name="destinationForBaggageDelay"
                          type="text"
                          onChange={this.handleChange('form.destinationForBaggageDelay')}
                          value={destinationForBaggageDelay}
                          disabled={isReadOnly}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={messages.destination}
                          />
                        </ErrorMessage>
                      </Validate>
                    </div>
                  </div>
                )}
                {travelSupplierInformation === 'Airline' && (
                  <div className={'ml-2'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.pleaseEnterYourFlightNumberAndDateBelow} />
                    </PageSectionHeader>
                    <div className={'row'}>
                      <div className={'col-sm-4 form-group'}>
                        <Validate
                          name="flightNumber"
                          validators={[checkFlightNumberOnly, required]}
                          group={this.validatorGroup}
                          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                          validChangeInGroup={this.validatorGroup.validChangeInGroup}
                          validationCounter={this.state.validationCounter}
                          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                          defaultValue={flightNumberForBaggageDelay}
                          fieldName={messages.flightNumber}
                        >
                          <Textbox
                            name="flightNumber"
                            type="text"
                            onChange={this.handleChange('form.flightNumberForBaggageDelay')}
                            value={flightNumberForBaggageDelay}
                            disabled={isReadOnly}
                          />
                          <ErrorMessage for="required">
                            <FormattedMessage
                              {...messages.isRequired}
                              values={messages.flightNumber}
                            />
                          </ErrorMessage>
                          <ErrorMessage for="checkFlightNumberOnly">
                            <FormattedMessage
                              {...messages.checkFlightNumber}
                              values={messages.flightNumber}
                            />
                          </ErrorMessage>
                        </Validate>
                      </div>
                      <div className={'col-sm-4 form-group'}>
                        <Validate
                          name="flightDate"
                          validators={[checkFlightDateOnly, required]}
                          group={this.validatorGroup}
                          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                          validChangeInGroup={this.validatorGroup.validChangeInGroup}
                          validationCounter={this.state.validationCounter}
                          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                          defaultValue={flightDateForBaggageDelay}
                          fieldName={messages.flightDate}
                        >
                          <FlightDatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="flightDate"
                            type="text"
                            onDayChange={this.handleDayChange('form.flightDateForBaggageDelay')}
                            value={flightDateForBaggageDelay}
                          />
                          <ErrorMessage for="required">
                            <FormattedMessage
                              {...messages.isRequired}
                              values={messages.flightDate}
                            />
                          </ErrorMessage>
                          <ErrorMessage for="checkFlightDateOnly">
                            <FormattedMessage
                              {...messages.checkFlightDate}
                              values={messages.flightDate}
                            />
                          </ErrorMessage>
                        </Validate>
                      </div>
                      <div className={'col-sm-4 form-group'}></div>
                    </div>
                    <div className={'row'}>
                      <div className={'col-sm-12 form-group'}>
                        <AsyncButton
                          id="searchFlightButton"
                          className={'btn-authentication'}
                          disabled={isReadOnly || (!isFlightNumberValid && !isFlightDateValid)}
                          loading={this.props.loading}
                          spinner={this.showSpinnerForElement('searchFlightButton')}
                          onClick={this.flightVerificationForBaggageDelay('flightDetailsForBaggageDelay')}
                        >
                          Search Flight
                        </AsyncButton>
                      </div>
                    </div>
                    {flightDetailsForBaggageDelay.onPendingFlighAPIRequest && (
                      <div className={'ml-2 row'}>
                        <div style={{ fontWeight: 'bold' }}>
                          <FormattedMessage {...messages.pendingFlightApiRequest} />
                        </div>
                      </div>
                    )}
                    {flightDetailsForBaggageDelay.callFailFlighAPIRequest && flightDetailsForBaggageDelay && flightDetailsForBaggageDelay.error && (
                      <div className={'row'}>
                        <div className={'col-sm-12'} style={{ color: 'red' }}>
                          {flightDetailsForBaggageDelay.error}
                        </div>
                      </div>
                    )}
                    {flightDetailsForBaggageDelay.callFailFlighAPIRequest && flightDetailsForBaggageDelay && flightDetailsForBaggageDelay.error && (
                      <div className={'row'}>
                        <div className={'form-group col-md-6'}>
                          <OptionsContainer>
                            <input
                              disabled={isReadOnly}
                              type="checkbox"
                              name="signature"
                              checked={flightDetailsForBaggageDelay.manuallyEnterFlight === true}
                              onChange={this.handleChange('form.flightDetailsForBaggageDelay.manuallyEnterFlight')}
                            />
                            <span>
                              <FormattedMessage {...messages.manuallyEnterFlight} />
                            </span>
                          </OptionsContainer>
                        </div>
                        <div className={'form-group col-md-6'}>
                        </div>
                      </div>
                    )}
                    {(showSectionFlightDetails && flightDetailsForBaggageDelay) && (
                      <div className={'row'}>
                        <div className={'col-sm-12'}>
                          <Section>
                            <ControlContainer>
                              <div className={'row'}>
                                <div className={'col-sm-2'}>
                                </div>
                                <div className={'col-sm-3'}>
                                  <h4>
                                    <FormattedMessage {...messages.flightDetails} />
                                  </h4>
                                </div>
                                <div className={'col-sm-3'}>
                                  <strong>
                                    <FormattedMessage {...messages.searchSuccess} />:
                                  </strong>{' '}
                                  {flightDetailsForBaggageDelay.success ? 'Yes' : 'No'}
                                </div>
                                <div className={'col-sm-2'}>
                                </div>
                              </div>
                              <div className={'row'}>
                                <div className={'col-sm-6 form-group'}>
                                  <PageSectionHeader>
                                    <FormattedMessage {...messages.flightNumber} />
                                  </PageSectionHeader>
                                  <Textbox
                                    name="flightNumber"
                                    type="text"
                                    onChange={this.handleChange('form.flightDetailsForBaggageDelay.flightNumber')}
                                    value={flightDetailsForBaggageDelay.flightNumber}
                                    disabled={isDisable}
                                  />
                                </div>
                                <div className={'col-sm-6 form-group'}>
                                  <PageSectionHeader>
                                    <FormattedMessage {...messages.flightDate} />
                                  </PageSectionHeader>
                                  <DatePicker
                                    name="flightDate"
                                    type="text"
                                    onDayChange={this.handleDayChange('form.flightDetailsForBaggageDelay.flightDate')}
                                    value={flightDetailsForBaggageDelay.flightDate}
                                    disabled={isDisable}
                                  />
                                </div>
                              </div>
                              <div className={'row'}>
                                <div className={'col-sm-12 form-group'}>
                                  <PageSectionHeader>
                                    <FormattedMessage {...messages.airline} />
                                  </PageSectionHeader>
                                  <Textbox
                                    name="airline"
                                    type="text"
                                    onChange={this.handleChange('form.flightDetailsForBaggageDelay.airline')}
                                    value={flightDetailsForBaggageDelay.airline}
                                    disabled={isDisable}
                                  />
                                </div>
                              </div>
                              <div className={'row'}>
                                <div className={'col-sm-6 form-group'}>
                                  <PageSectionHeader>
                                    <FormattedMessage {...messages.originAirport} />
                                  </PageSectionHeader>
                                  <Textbox
                                    name="originAirport"
                                    type="text"
                                    onChange={this.handleChange('form.flightDetailsForBaggageDelay.originAirport')}
                                    value={flightDetailsForBaggageDelay.originAirport}
                                    disabled={isDisable}
                                  />
                                </div>
                                <div className={'col-sm-6 form-group'}>
                                  <PageSectionHeader>
                                    <FormattedMessage {...messages.destinationAirport} />
                                  </PageSectionHeader>
                                  <Textbox
                                    name="destinationAirport"
                                    type="text"
                                    onChange={this.handleChange('form.flightDetailsForBaggageDelay.destinationAirport')}
                                    value={flightDetailsForBaggageDelay.destinationAirport}
                                    disabled={isDisable}
                                  />
                                </div>
                              </div>
                            </ControlContainer>
                          </Section>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
          <div className={'ml-2'}>
            <div className="row">
              <div className="form-group col-md-6 col-sm-6">
                <Validate
                  name="dateWhenYourLuggageWasDelayed"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateWhenYourLuggageWasDelayed}
                  fieldName={messages.dateWhenYourLuggageWasDelayed}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateWhenYourLuggageWasDelayed"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateWhenYourLuggageWasDelayed')}
                    value={dateWhenYourLuggageWasDelayed}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateWhenYourLuggageWasDelayed}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateWhenYourLuggageWasDelayed}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-5 col-sm-5">
                <Validate
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  name="timeWhenYourLuggageWasDelayed"
                  group={this.validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  defaultValue={newTimeWhenYourLuggageWasDelayed}
                  fieldName={messages.timeWhenYourLuggageWasDelayed}
                >
                  <TimePickerInput
                    allowEmpty
                    showSecond={false}
                    onChange={this.onChange('form.timeWhenYourLuggageWasDelayed')}
                    value={newTimeWhenYourLuggageWasDelayed}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.timeWhenYourLuggageWasDelayed}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-md-1 col-sm-1 form-group'}>
              </div>
            </div>
            <div className="row">
              <div className="form-group col-md-6 col-sm-6">
                <Validate
                  name="dateWhenYourLuggageWasReturned"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={dateWhenYourLuggageWasReturned}
                  fieldName={messages.dateWhenYourLuggageWasReturned}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="dateWhenYourLuggageWasReturned"
                    type="text"
                    onDayChange={this.handleDayChange('form.dateWhenYourLuggageWasReturned')}
                    value={dateWhenYourLuggageWasReturned}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateWhenYourLuggageWasReturned}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateWhenYourLuggageWasReturned}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className="form-group col-md-5 col-sm-5">
                <Validate
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  name="timeWhenYourLuggageWasReturned"
                  group={this.validatorGroup}
                  validators={[required]}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  defaultValue={newTimeWhenYourLuggageWasReturned}
                  fieldName={messages.timeWhenYourLuggageWasReturned}
                >
                  <TimePickerInput
                    allowEmpty
                    showSecond={false}
                    onChange={this.onChange('form.timeWhenYourLuggageWasReturned')}
                    value={newTimeWhenYourLuggageWasReturned}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.timeWhenYourLuggageWasReturned}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-md-1 col-sm-1 form-group'}>
              </div>
            </div>
          </div>
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.haveYouMadeAClaimWithYourTravelProvider} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={haveYouMadeAClaimWithYourTravelProvider === 'true'}
                    onChange={this.handleChange('form.haveYouMadeAClaimWithYourTravelProvider')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={haveYouMadeAClaimWithYourTravelProvider === 'false'}
                    onChange={this.handleChange('form.haveYouMadeAClaimWithYourTravelProvider')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
          <div className={'ml-2'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.descriptionOfItems} />
            </PageSectionHeader>
            {this.renderDescriptionOfItemsForBaggageDelay()}
          </div>
        </div>
      )
    );
  }

  renderDescriptionOfItems() {
    const { descriptionOfItems } = this.props.form;
    const newDescriptionOfItems = this.appendIds(descriptionOfItems);
    const { isSummary, submitted, depreciationTypes, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <DescriptionList
          data={newDescriptionOfItems}
          onChange={this.onDescriptionOfItemsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          depreciationTypes={depreciationTypes}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderForDamagedLostOrStolenLuggage() {
    const {
      areYouClaimingForDamagedLostOrStolenLuggage,
      areYouClaimingFor1,
      companyYouWereTravelingWith,
      areYouClaimingFor2,
      originForDamaged,
      destinationForDamaged,
      areYouClaimingFor3,
      ifOtherPleaseDescribeWhere,
      whoDidYouReportTo,
      ifOtherPleaseDescribe2,
      reportReferenceNumber,
      reportDate,
      organizationNameReportedTo,
      flightNumberForDamaged,
      flightDateForDamaged,
      flightDetailsForDamaged = {},
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, jsonVersion } = this.props;
    const isReadOnly = submitted || isSummary;
    const isFlightNumberValid = checkFlightNumberOnly(flightNumberForDamaged);
    const isFlightDateValid = checkFlightDateOnly(flightDateForDamaged);
    const showSectionFlightDetails = flightDetailsForDamaged && (flightDetailsForDamaged.onSuccessFlighAPIRequest || flightDetailsForDamaged.callFailFlighAPIRequest);
    const isDisable = isReadOnly || (flightDetailsForDamaged && flightDetailsForDamaged.onSuccessFlighAPIRequest) || !(flightDetailsForDamaged && flightDetailsForDamaged.manuallyEnterFlight);
    const isVersion15AndAbove = jsonVersion >= 15;
    return (
      areYouClaimingForDamagedLostOrStolenLuggage === 'true' && (
        <div>
          <div className={'ml-5'}>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="nationalIdOrVisa"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={areYouClaimingFor1}
                  fieldName={messages.areYouClaimingForV2}
                >
                  <FlexBox>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        value="Loss"
                        checked={areYouClaimingFor1 === 'Loss'}
                        onChange={this.handleChangeClaimingFor('form.areYouClaimingFor1')}
                      />
                      <FormattedMessage {...messages.loss} />
                    </OptionsContainer>
                  </FlexBox>
                  <FlexBox className={'pt-2'}>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        value="Theft"
                        checked={areYouClaimingFor1 === 'Theft'}
                        onChange={this.handleChangeClaimingFor('form.areYouClaimingFor1')}
                      />
                      <FormattedMessage {...messages.theft} />
                    </OptionsContainer>
                  </FlexBox>
                  <FlexBox className={'pt-2'}>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        value="Damage"
                        checked={areYouClaimingFor1 === 'Damage'}
                        onChange={this.handleChangeClaimingFor('form.areYouClaimingFor1')}
                      />
                      <FormattedMessage {...messages.damage} />
                    </OptionsContainer>
                  </FlexBox>
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.areYouClaimingForV2}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
            <div className={'row'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.travelSupplierProviderInformation} />
              </PageSectionHeader>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="companyYouWereTravelingWith"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={companyYouWereTravelingWith}
                  fieldName={messages.companyYouWereTravelingWith}
                >
                  <Textbox
                    name="companyYouWereTravelingWith"
                    type="text"
                    onChange={this.handleChange('form.companyYouWereTravelingWith')}
                    value={companyYouWereTravelingWith}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.companyYouWereTravelingWith}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}></div>
            </div>
            {isVersion15AndAbove && (
              <FlightDetailsForDamagedLost
                form={this.props.form}
                getFlightStatus={this.props.getFlightStatus}
                isReadOnly={isReadOnly}
                summaryFormValue={this.summaryFormValue}
                isSummary={isSummary}
                handleChangeTypeOfTransport={this.handleChangeTypeOfTransport}
                checkFlightNumberOnly={checkFlightNumberOnly}
                checkFlightDateOnly={checkFlightDateOnly}
                loading={this.props.loading}
                handleChange={this.handleChange}
                handleDayChange={this.handleDayChange}
                handleChangeFlightDetail={this.handleChangeFlightDetail}
                validatorGroup={this.validatorGroup}
                validationCounter={this.state.validationCounter}
                flightVerificationForDamaged={this.flightVerificationForDamaged}
                showSpinnerForElement={this.showSpinnerForElement}
                handleFlightSelection={this.handleFlightSelection}
              />
            )}
            {!isVersion15AndAbove && (
              <div>
                <div className={'row ml-2'}>
                  <div className={'col-sm-12 form-group'}>
                    <FlexBox>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="Tour Operator"
                          checked={areYouClaimingFor2 === 'Tour Operator'}
                          onChange={this.handleChangeClaimingFor('form.areYouClaimingFor2')}
                          onClick={this.props.onResetFormAirlineForDamaged}
                        />
                        <FormattedMessage {...messages.tourOperator} />
                      </OptionsContainer>
                    </FlexBox>
                    <FlexBox className={'pt-2'}>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="Cruise Line"
                          checked={areYouClaimingFor2 === 'Cruise Line'}
                          onChange={this.handleChangeClaimingFor('form.areYouClaimingFor2')}
                          onClick={this.props.onResetFormAirlineForDamaged}
                        />
                        <FormattedMessage {...messages.cruiseLine} />
                      </OptionsContainer>
                    </FlexBox>
                    <FlexBox className={'pt-2'}>
                      <OptionsContainer>
                        <input
                          disabled={isReadOnly}
                          type="radio"
                          value="Airline"
                          checked={areYouClaimingFor2 === 'Airline'}
                          onChange={this.handleChangeClaimingFor('form.areYouClaimingFor2')}
                          onClick={this.props.onResetFormAirlineForDamaged}
                        />
                        <FormattedMessage {...messages.airline} />
                      </OptionsContainer>
                    </FlexBox>
                  </div>
                </div>
                {(areYouClaimingFor2 === 'Tour Operator' || areYouClaimingFor2 === 'Cruise Line') && (
                  <div className={'row'}>
                    <div className={'col-sm-6 form-group'}>
                      <Validate
                        name="originForDamaged"
                        validators={[required]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={originForDamaged}
                        fieldName={messages.origin}
                      >
                        <Textbox
                          name="originForDamaged"
                          type="text"
                          onChange={this.handleChange('form.originForDamaged')}
                          value={originForDamaged}
                          disabled={isReadOnly}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={messages.origin}
                          />
                        </ErrorMessage>
                      </Validate>
                    </div>
                    <div className={'col-sm-6 form-group'}>
                      <Validate
                        name="destinationForDamaged"
                        validators={[required]}
                        group={this.validatorGroup}
                        addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                        validChangeInGroup={this.validatorGroup.validChangeInGroup}
                        validationCounter={this.state.validationCounter}
                        validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                        defaultValue={destinationForDamaged}
                        fieldName={messages.destination}
                      >
                        <Textbox
                          name="destinationForDamaged"
                          type="text"
                          onChange={this.handleChange('form.destinationForDamaged')}
                          value={destinationForDamaged}
                          disabled={isReadOnly}
                        />
                        <ErrorMessage for="required">
                          <FormattedMessage
                            {...messages.isRequired}
                            values={messages.destination}
                          />
                        </ErrorMessage>
                      </Validate>
                    </div>
                  </div>
                )}
                {areYouClaimingFor2 === 'Airline' && (
                  <div className={'ml-2'}>
                    <PageSectionHeader>
                      <FormattedMessage {...messages.pleaseEnterYourFlightNumberAndDateBelow} />
                    </PageSectionHeader>
                    <div className={'row'}>
                      <div className={'col-sm-4 form-group'}>
                        <Validate
                          name="flightNumber"
                          validators={[checkFlightNumberOnly, required]}
                          group={this.validatorGroup}
                          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                          validChangeInGroup={this.validatorGroup.validChangeInGroup}
                          validationCounter={this.state.validationCounter}
                          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                          defaultValue={flightNumberForDamaged}
                          fieldName={messages.flightNumber}
                        >
                          <Textbox
                            name="flightNumber"
                            type="text"
                            onChange={this.handleChange('form.flightNumberForDamaged')}
                            value={flightNumberForDamaged}
                            disabled={isReadOnly}
                          />
                          <ErrorMessage for="required">
                            <FormattedMessage
                              {...messages.isRequired}
                              values={messages.flightNumber}
                            />
                          </ErrorMessage>
                          <ErrorMessage for="checkFlightNumberOnly">
                            <FormattedMessage
                              {...messages.checkFlightNumber}
                              values={messages.flightNumber}
                            />
                          </ErrorMessage>
                        </Validate>
                      </div>
                      <div className={'col-sm-4 form-group'}>
                        <Validate
                          name="flightDate"
                          validators={[checkFlightDateOnly, required]}
                          group={this.validatorGroup}
                          addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                          validChangeInGroup={this.validatorGroup.validChangeInGroup}
                          validationCounter={this.state.validationCounter}
                          validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                          defaultValue={flightDateForDamaged}
                          fieldName={messages.flightDate}
                        >
                          <FlightDatePicker
                            position={'bottom-start'}
                            disabled={isReadOnly}
                            name="flightDate"
                            type="text"
                            onDayChange={this.handleDayChange('form.flightDateForDamaged')}
                            value={flightDateForDamaged}
                          />
                          <ErrorMessage for="required">
                            <FormattedMessage
                              {...messages.isRequired}
                              values={messages.flightDate}
                            />
                          </ErrorMessage>
                          <ErrorMessage for="checkFlightDateOnly">
                            <FormattedMessage
                              {...messages.checkFlightDate}
                              values={messages.flightDate}
                            />
                          </ErrorMessage>
                        </Validate>
                      </div>
                      <div className={'col-sm-4 form-group'}></div>
                    </div>
                    <div className={'row'}>
                      <div className={'col-sm-12 form-group'}>
                        <AsyncButton
                          id="searchFlightButton"
                          className={'btn-authentication'}
                          disabled={isReadOnly || (!isFlightNumberValid && !isFlightDateValid)}
                          loading={this.props.loading}
                          spinner={this.showSpinnerForElement('searchFlightButton')}
                          onClick={this.flightVerificationForDamaged('flightDetailsForDamaged')}
                        >
                          Search Flight
                        </AsyncButton>
                      </div>
                    </div>
                    {flightDetailsForDamaged.onPendingFlighAPIRequest && (
                      <div className={'ml-2 row'}>
                        <div style={{ fontWeight: 'bold' }}>
                          <FormattedMessage {...messages.pendingFlightApiRequest} />
                        </div>
                      </div>
                    )}
                    {flightDetailsForDamaged.callFailFlighAPIRequest && flightDetailsForDamaged && flightDetailsForDamaged.error && (
                      <div className={'row'}>
                        <div className={'col-sm-12'} style={{ color: 'red' }}>
                          {flightDetailsForDamaged.error}
                        </div>
                      </div>
                    )}
                    {flightDetailsForDamaged.callFailFlighAPIRequest && flightDetailsForDamaged && flightDetailsForDamaged.error && (
                      <div className={'row'}>
                        <div className={'form-group col-md-6'}>
                          <OptionsContainer>
                            <input
                              disabled={isReadOnly}
                              type="checkbox"
                              name="signature"
                              checked={flightDetailsForDamaged.manuallyEnterFlight === true}
                              onChange={this.handleChange('form.flightDetailsForDamaged.manuallyEnterFlight')}
                            />
                            <span>
                              <FormattedMessage {...messages.manuallyEnterFlight} />
                            </span>
                          </OptionsContainer>
                        </div>
                        <div className={'form-group col-md-6'}>
                        </div>
                      </div>
                    )}
                    {(showSectionFlightDetails && flightDetailsForDamaged) && (
                      <div className={'row'}>
                        <div className={'col-sm-12'}>
                          <Section>
                            <ControlContainer>
                              <div className={'row'}>
                                <div className={'col-sm-2'}>
                                </div>
                                <div className={'col-sm-3'}>
                                  <h4>
                                    <FormattedMessage {...messages.flightDetails} />
                                  </h4>
                                </div>
                                <div className={'col-sm-3'}>
                                  <strong>
                                    <FormattedMessage {...messages.searchSuccess} />:
                                  </strong>{' '}
                                  {flightDetailsForDamaged.success ? 'Yes' : 'No'}
                                </div>
                                <div className={'col-sm-2'}>
                                </div>
                              </div>
                              <div className={'row'}>
                                <div className={'col-sm-6 form-group'}>
                                  <PageSectionHeader>
                                    <FormattedMessage {...messages.flightNumber} />
                                  </PageSectionHeader>
                                  <Textbox
                                    name="flightNumber"
                                    type="text"
                                    onChange={this.handleChange('form.flightDetailsForDamaged.flightNumber')}
                                    value={flightDetailsForDamaged.flightNumber}
                                    disabled={isDisable}
                                  />
                                </div>
                                <div className={'col-sm-6 form-group'}>
                                  <PageSectionHeader>
                                    <FormattedMessage {...messages.flightDate} />
                                  </PageSectionHeader>
                                  <DatePicker
                                    name="flightDate"
                                    type="text"
                                    onDayChange={this.handleDayChange('form.flightDetailsForDamaged.flightDate')}
                                    value={flightDetailsForDamaged.flightDate}
                                    disabled={isDisable}
                                  />
                                </div>
                              </div>
                              <div className={'row'}>
                                <div className={'col-sm-12 form-group'}>
                                  <PageSectionHeader>
                                    <FormattedMessage {...messages.airline} />
                                  </PageSectionHeader>
                                  <Textbox
                                    name="airline"
                                    type="text"
                                    onChange={this.handleChange('form.flightDetailsForDamaged.airline')}
                                    value={flightDetailsForDamaged.airline}
                                    disabled={isDisable}
                                  />
                                </div>
                              </div>
                              <div className={'row'}>
                                <div className={'col-sm-6 form-group'}>
                                  <PageSectionHeader>
                                    <FormattedMessage {...messages.originAirport} />
                                  </PageSectionHeader>
                                  <Textbox
                                    name="originAirport"
                                    type="text"
                                    onChange={this.handleChange('form.flightDetailsForDamaged.originAirport')}
                                    value={flightDetailsForDamaged.originAirport}
                                    disabled={isDisable}
                                  />
                                </div>
                                <div className={'col-sm-6 form-group'}>
                                  <PageSectionHeader>
                                    <FormattedMessage {...messages.destinationAirport} />
                                  </PageSectionHeader>
                                  <Textbox
                                    name="destinationAirport"
                                    type="text"
                                    onChange={this.handleChange('form.flightDetailsForDamaged.destinationAirport')}
                                    value={flightDetailsForDamaged.destinationAirport}
                                    disabled={isDisable}
                                  />
                                </div>
                              </div>
                            </ControlContainer>
                          </Section>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
          <div className={'ml-3'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.lossInformation} />
            </PageSectionHeader>
            <div className={'ml-3 row'}>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.areYouClaimingFor} />
                </PageSectionHeader>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="Airport"
                      checked={areYouClaimingFor3 === 'Airport'}
                      onChange={this.handleChangeClaimingFor('form.areYouClaimingFor3')}
                    />
                    <FormattedMessage {...messages.airport} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="Hotel"
                      checked={areYouClaimingFor3 === 'Hotel'}
                      onChange={this.handleChangeClaimingFor('form.areYouClaimingFor3')}
                    />
                    <FormattedMessage {...messages.hotel} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="Rental Agency"
                      checked={areYouClaimingFor3 === 'Rental Agency'}
                      onChange={this.handleChangeClaimingFor('form.areYouClaimingFor3')}
                    />
                    <FormattedMessage {...messages.rentalAgency} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="Other"
                      checked={areYouClaimingFor3 === 'Other'}
                      onChange={this.handleChangeClaimingFor('form.areYouClaimingFor3')}
                    />
                    <FormattedMessage {...messages.other} />
                  </OptionsContainer>
                </FlexBox>
              </div>
              {areYouClaimingFor3 === 'Other' &&
                <div className={'col-sm-8 form-group'}>
                  <Validate
                    name="ifOtherPleaseDescribeWhere"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={ifOtherPleaseDescribeWhere}
                    fieldName={messages.ifOtherPleaseDescribeWhere}
                  >
                    <TextArea
                      disabled={isReadOnly}
                      name="ifOtherPleaseDescribeWhere"
                      type="text"
                      onChange={this.handleChange('form.ifOtherPleaseDescribeWhere')}
                      value={ifOtherPleaseDescribeWhere}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.ifOtherPleaseDescribeWhere}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>}
              {areYouClaimingFor3 !== 'Other' &&
                <div className={'col-sm-8 form-group'}>
                  <PageSectionHeader>
                    <FormattedMessage {...messages.ifOtherPleaseDescribeWhere} />
                  </PageSectionHeader>
                  <TextArea
                    disabled={isReadOnly}
                    name="ifOtherPleaseDescribe"
                    type="text"
                    onChange={this.handleChange('form.ifOtherPleaseDescribeWhere')}
                    value={ifOtherPleaseDescribeWhere}
                    isSummary={isSummary}
                  />
                </div>}
            </div>
            <div className={'ml-3 row'}>
              <div className={'col-sm-4 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.whoDidYouReportTo} />
                </PageSectionHeader>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="Police"
                      checked={whoDidYouReportTo === 'Police'}
                      onChange={this.handleChangeClaimingFor('form.whoDidYouReportTo')}
                    />
                    <FormattedMessage {...messages.police} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="Hotel"
                      checked={whoDidYouReportTo === 'Hotel'}
                      onChange={this.handleChangeClaimingFor('form.whoDidYouReportTo')}
                    />
                    <FormattedMessage {...messages.hotel} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="Hospital Management"
                      checked={whoDidYouReportTo === 'Hospital Management'}
                      onChange={this.handleChangeClaimingFor('form.whoDidYouReportTo')}
                    />
                    <FormattedMessage {...messages.hospitalManagement} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="Cruise Ship"
                      checked={whoDidYouReportTo === 'Cruise Ship'}
                      onChange={this.handleChangeClaimingFor('form.whoDidYouReportTo')}
                    />
                    <FormattedMessage {...messages.cruiseShip} />
                  </OptionsContainer>
                </FlexBox>
              </div>
              <div className={'mt-4 col-sm-3 form-group'}>
                <FlexBox>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="Tour Guide"
                      checked={whoDidYouReportTo === 'Tour Guide'}
                      onChange={this.handleChangeClaimingFor('form.whoDidYouReportTo')}
                    />
                    <FormattedMessage {...messages.tourGuide} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="Other Report"
                      checked={whoDidYouReportTo === 'Other Report'}
                      onChange={this.handleChangeClaimingFor('form.whoDidYouReportTo')}
                    />
                    <FormattedMessage {...messages.other} />
                  </OptionsContainer>
                </FlexBox>
                <FlexBox className={'pt-2'}>
                  <OptionsContainer>
                    <input
                      disabled={isReadOnly}
                      type="radio"
                      value="Not Reported"
                      checked={whoDidYouReportTo === 'Not Reported'}
                      onChange={this.handleChangeClaimingFor('form.whoDidYouReportTo')}
                    />
                    <FormattedMessage {...messages.notReported} />
                  </OptionsContainer>
                </FlexBox>
              </div>
              {whoDidYouReportTo === 'Other Report' &&
                <div className={'col-sm-5 form-group'}>
                  <Validate
                    name="pleaseDescribeWhatOccurred"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={ifOtherPleaseDescribe2}
                    fieldName={messages.ifOtherPleaseDescribe}
                  >
                    <TextArea
                      disabled={isReadOnly}
                      name="ifOtherPleaseDescribe2"
                      type="text"
                      onChange={this.handleChange('form.ifOtherPleaseDescribe2')}
                      value={ifOtherPleaseDescribe2}
                      isSummary={isSummary}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.ifOtherPleaseDescribe}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>}
              {whoDidYouReportTo !== 'Other Report' &&
                <div className={'col-sm-5 form-group'}>
                  <PageSectionHeader>
                    <FormattedMessage {...messages.ifOtherPleaseDescribe} />
                  </PageSectionHeader>
                  <TextArea
                    disabled={isReadOnly}
                    name="ifOtherPleaseDescribe"
                    type="text"
                    onChange={this.handleChange('form.ifOtherPleaseDescribe2')}
                    value={ifOtherPleaseDescribe2}
                    isSummary={isSummary}
                  />
                </div>}
            </div>
          </div>
          {whoDidYouReportTo !== 'Not Reported' &&
            <div className={'ml-4'}>
              <div className={'ml-2 row'}>
                <div className={'col-sm-6 form-group'}>
                  <Validate
                    name="reportReferenceNumber"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={reportReferenceNumber}
                    fieldName={messages.reportReferenceNumber}
                  >
                    <Textbox
                      name="reportReferenceNumber"
                      type="text"
                      onChange={this.handleChange('form.reportReferenceNumber')}
                      value={reportReferenceNumber}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.reportReferenceNumber}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
                <div className={'col-sm-6 form-group'}>
                  <Validate
                    name="departureDate"
                    validators={[checkDateOnly, required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={reportDate}
                    fieldName={messages.reportDate}
                  >
                    <DatePicker
                      position={'bottom-start'}
                      disabled={isReadOnly}
                      name="reportDate"
                      type="text"
                      onDayChange={this.handleDayChange('form.reportDate')}
                      value={reportDate}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.reportDate}
                      />
                    </ErrorMessage>
                    <ErrorMessage for="checkDateOnly">
                      <FormattedMessage
                        {...messages.checkEventDate}
                        values={messages.reportDate}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
              </div>
              <div className={'ml-2 row'}>
                <div className={'col-sm-12 form-group'}>
                  <Validate
                    name="organizationNameReportedTo"
                    validators={[required]}
                    group={this.validatorGroup}
                    addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                    validChangeInGroup={this.validatorGroup.validChangeInGroup}
                    validationCounter={this.state.validationCounter}
                    validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                    defaultValue={organizationNameReportedTo}
                    fieldName={messages.organizationNameReportedTo}
                  >
                    <Textbox
                      name="organizationNameReportedTo"
                      type="text"
                      onChange={this.handleChange('form.organizationNameReportedTo')}
                      value={organizationNameReportedTo}
                      disabled={isReadOnly}
                    />
                    <ErrorMessage for="required">
                      <FormattedMessage
                        {...messages.isRequired}
                        values={messages.organizationNameReportedTo}
                      />
                    </ErrorMessage>
                  </Validate>
                </div>
              </div>
            </div>}
          <div className={'ml-2'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.descriptionOfItems} />
            </PageSectionHeader>
            {this.renderDescriptionOfItems()}
          </div>
        </div>
      )
    );
  }

  render() {
    const {
      areYouClaimingForDamagedLostOrStolenLuggage,
      areYouClaimingForBaggageDelay,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, loading } = this.props;
    const isRenderAreYouClaimingForBaggageDelay = !!stepBaggageAndPersonalItemsStarrLookup.areYouClaimingForBaggageDelay.claimCode;
    const isRenderAreYouClaimingForDamagedLostOrStolenLuggage = !!stepBaggageAndPersonalItemsStarrLookup.areYouClaimingForDamaged.claimCode;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="app-content">
        <PageSectionHeader>
          <FormattedMessage {...messages.thisSectionRelatesToExpensesForYourBaggagePersonalItemsCashAndTravelDocuments} />
        </PageSectionHeader>
        {isRenderAreYouClaimingForDamagedLostOrStolenLuggage &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.areYouClaimingForDamagedLostOrStolenLuggage} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={areYouClaimingForDamagedLostOrStolenLuggage === 'true'}
                    onChange={this.handleChange('form.areYouClaimingForDamagedLostOrStolenLuggage')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={areYouClaimingForDamagedLostOrStolenLuggage === 'false'}
                    onChange={this.handleChange('form.areYouClaimingForDamagedLostOrStolenLuggage')}
                    onClick={this.props.onResetFormTravelInterruption}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>}
        {isRenderAreYouClaimingForDamagedLostOrStolenLuggage && this.renderForDamagedLostOrStolenLuggage()}
        {isRenderAreYouClaimingForBaggageDelay &&
          <div className={'row'}>
            <div className={'col-sm-6 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.areYouClaimingForBaggageDelay} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={areYouClaimingForBaggageDelay === 'true'}
                    onChange={this.handleChange('form.areYouClaimingForBaggageDelay')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={areYouClaimingForBaggageDelay === 'false'}
                    onChange={this.handleChange('form.areYouClaimingForBaggageDelay')}
                    onClick={this.props.onResetFormTravelDelay}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>}
        {isRenderAreYouClaimingForBaggageDelay && this.renderForBaggageDelay()}
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

StepBaggageAndPersonalItemsStarr.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetFormTravelInterruption: PropTypes.func,
  onResetFormTravelDelay: PropTypes.func,
  onResetFormAirlineForDamaged: PropTypes.func,
  onResetFormAirlineBaggageDelay: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  depreciationTypes: PropTypes.any,
  insuredsList: PropTypes.any,
  isClaimForFieldEnabled: PropTypes.bool,
  getFlightStatus: PropTypes.func,
  jsonVersion: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStepBaggageAndPersonalItemsStarr(),
  errors: makeSelectStepBaggageAndPersonalItemsStarrErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  depreciationTypes: makeSelectDepreciationTypes(),
  insuredsList: makeSelectInsuredsList(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
  jsonVersion: makeSelectJSONVersion(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormTravelInterruption: () => dispatch(resetFormTravelInterruption()),
  onResetFormTravelDelay: () => dispatch(resetFormTravelDelay()),
  onResetFormAirlineForDamaged: () => dispatch(resetFormAirlineForDamaged()),
  onResetFormAirlineBaggageDelay: () => dispatch(resetFormAirlineBaggageDelay()),
  onResetFormData: () => dispatch(resetFormData()),
  getFlightStatus: (flightNumber, flightDate, flightObjectName, currentStepName) =>
    dispatch(getFlightStatusRequest(flightNumber, flightDate, flightObjectName, currentStepName)),
  resetFormFields: (payload) => dispatch(resetFormFields(payload)),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'stepBaggageAndPersonalItemsStarr', reducer });

export default compose(
  withReducer,
  withConnect
)(StepBaggageAndPersonalItemsStarr);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.Starr.StepBaggageAndPersonalItems/index.js